module.exports = __webpack_public_path__ + "images/xn--fgra-ypa6a-ie-dns-996w.webp";